import { useUpdateTemplateMutation } from '@/graphql/types';

export default function (template: {
  id: string;
  name: string;
  description: string;
  templateId: string;
  attributes: {
    id: string | null;
    sc1187: any;
    sc1009: any;
    sensorMapping: string;
    description: string;
  }[];
}) {
  const mutation = useUpdateTemplateMutation({});

  function call() {
    return mutation.mutate({
      input: {
        id: template.id,
        name: template.name,
        description: template.description,
        templateId: +template.templateId,
        attributes: [
          ...template.attributes.map(attr =>
            Object.assign(
              {},
              {
                id: attr.id === null || attr.id === '' ? null : attr.id,
                sc1187Id: attr.sc1187.id,
                sc1009Id: attr.sc1009.id,
                sensorMapping: attr.sensorMapping,
                description: attr.description
              }
            )
          )
        ]
      }
    });
  }

  return {
    ...mutation,
    call
  };
}
